import { logWarn } from '../logger';
import { timeZoneMapping } from './timeZoneMapping';
const FALLBACK_REGION = 'eu';
export const getFallbackRegion = () => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone) {
        const regionFromTimeZone = timeZone.split('/')[0].toLowerCase();
        if (regionFromTimeZone in timeZoneMapping) {
            return timeZoneMapping[regionFromTimeZone];
        }
    }
    logWarn(`Provided region is not supported - defaulting region to ${FALLBACK_REGION}`);
    return FALLBACK_REGION;
};
